import { message as EeveeMessage } from '@fuxi/eevee-ui';
import { TaskJson, ParentTaskTemplate, ParentTaskTemplateDetail } from 'common/types';
import { getNormalParams, FastApiAxiosInstance } from 'common/service/axiosInstances';

const taskTempSettings = {
  getParentTemplateInstanceList: (_query, projectId, _num, _page) => {
    const params = { ...getNormalParams('getParentTemplateInstanceList'), _page, _num, _query, projectId };
    return FastApiAxiosInstance.get<{ total: number; items: ParentTaskTemplate[] }>(
      '/api/v1/template/getParentTemplateInstanceList',
      { params },
    );
  },
  getParentTemplateInfo: async (parentTemplateId: string | number, projectId: string | number) => {
    const params = {
      ...getNormalParams('getParentTemplateInfo'),
      parentTemplateId: Number(parentTemplateId),
      projectId: Number(projectId),
    };
    return await FastApiAxiosInstance.get<ParentTaskTemplateDetail>(`/api/v1/template/getParentTemplateInfo`, {
      params,
    });
    // return data;
  },
  addParentTemplate: async (projectId: number | string, templateName: string, parentTemplateJson: TaskJson[]) => {
    const { data, code, message } = await FastApiAxiosInstance.post<any, ExtendAxioResponse>(
      '/api/v1/template/addParentTemplate',
      { ...getNormalParams('addParentTemplate'), templateName, parentTemplateJson, projectId: Number(projectId) },
    );
    const hasError = code !== 0;
    if (hasError) {
      EeveeMessage.error(message || '创建模版失败');
    } else {
      EeveeMessage.success('成功');
    }
    return code === 0;
  },
  removeParentTemplate: async (projectId: number | string, parentTemplateId: number) => {
    const { data, code, message } = await FastApiAxiosInstance.post<any, ExtendAxioResponse>(
      '/api/v1/template/removeParentTemplate',
      { ...getNormalParams('removeParentTemplate'), projectId: Number(projectId), parentTemplateId },
    );
    const hasError = code !== 0;
    if (hasError) {
      EeveeMessage.error(message || '删除模版失败');
    } else {
      EeveeMessage.success('成功');
    }
    return code === 0;
  },
  updateParentTemplate: async (
    projectId: number | string,
    parentTemplateId: number,
    templateName: string,
    stageTemplateSortList?: number[],
  ) => {
    try {
      const { data, code, message } = await FastApiAxiosInstance.post<any, ExtendAxioResponse>(
        '/api/v1/template/updateParentTemplate',
        {
          ...getNormalParams('updateParentTemplate'),
          templateName,
          stageTemplateSortList,
          parentTemplateId,
          projectId: Number(projectId),
        },
      );
      return code === 0;
    } catch (e) {
      return false;
    }
  },
  removeStageTemplate: async (projectId: number | string, parentTemplateId: number, stageTemplateId: number) => {
    try {
      const { data, code, message } = await FastApiAxiosInstance.post<any, ExtendAxioResponse>(
        '/api/v1/template/removeStageTemplate',
        { ...getNormalParams('removeStageTemplate'), stageTemplateId, projectId: Number(projectId), parentTemplateId },
      );
      return code === 0;
    } catch (e) {
      return false;
    }
  },
  updateStageTemplate: async (
    task: TaskJson,
    projectId: number | string,
    parentTemplateId: number,
    stageTemplateId?: number,
  ) => {
    try {
      const { workFlow, launcherId, stage, template } = task;
      const { data, code, message } = await FastApiAxiosInstance.post<any, ExtendAxioResponse>(
        '/api/v1/template/updateStageTemplate',
        {
          ...getNormalParams('updateStageTemplate'),
          projectId: Number(projectId),
          parentTemplateId,
          workFlow,
          launcherId,
          stage,
          template,
          stageTemplateId,
        },
      );
      return data?.id;
    } catch (e) {
      return false;
    }
  },
};

export default taskTempSettings;
